import { useMutation } from "@tanstack/react-query";
import { SystemLicenses } from "@graylog/enterprise-api";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
const acknowledgeUsageWarning = async () => SystemLicenses.acknowledgeTrafficThreshold();
const useUsageWarningAcknowledgementMutation = () => {
  const acknowledge = useMutation({
    mutationFn: acknowledgeUsageWarning,
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.usage_ack_failed", { ns: "enterprise_license", error: errorThrown }),
        i18n.t("notifications.usage_ack_failed_title", { ns: "enterprise_license" })
      );
    },
    onSuccess: () => {
      UserNotification.success(
        i18n.t("notifications.usage_ack_success", { ns: "enterprise_license" }),
        i18n.t("notifications.success_title", { ns: "enterprise_license" })
      );
    }
  });
  return { acknowledgeNotifcation: acknowledge.mutateAsync };
};
export default useUsageWarningAcknowledgementMutation;
